mmf_modules.define('utils/social',[
    'jquery',
    'utils/ensure_dataLayer',
    'third_party/fb',
    'utils/user'
], function (
    $,
    dataLayer,
    MmfFacebook,
    User
) {
    'use strict';

    var Social = {};

    Social.fb_session = false;

    var mmf_facebook = new MmfFacebook();

    var _onLoginStatusCheck = function (is_logged_in, resp) {
        mmf_facebook.FB.api('/me', function (response) {
            if (response.first_name) {
                Social.fb_session = true;
                $('.fb_welcome_message').html('Welcome, ' + response.first_name + '!');
                if (window.location.href.search("fb_source") !== -1 && !User.id) {
                    Social.facebook_custom_login_fn();
                }
            }
        });
    };

    Social.Facebook = {
        Init: function () {

            mmf_facebook.getLoginStatus(_onLoginStatusCheck);

            var $body = $('body');
            $body.on('click', '.facebook_custom_login_fn', function (event) {
                event.preventDefault();
                Social.facebook_custom_login_fn();
            });

            $body.on('click', '.share_on_facebook', function (e) {
                e.preventDefault();
                var winWidth = 611,
                    url = $(this).attr('href'),
                    winHeight = 286,
                    winTop = (screen.height / 2) - (winHeight / 2),
                    winLeft = (screen.width / 2) - (winWidth / 2);

                window.open('http://www.facebook.com/sharer.php?' + '&u=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            });
        }
    };

    Social.facebook_custom_login_fn = function () {
        dataLayer.push({
            'event': 'classic event',
            'category': 'Registration',
            'action': 'FB_Login_Register_Button',
            'label': window.location.href
        });
    };

    return Social;
});

